import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'recommendation.page.title': {
    id: 'recommendation.page.title',
    defaultMessage: 'Recommendations | {siteName}',
    description: 'recommendation page title',
  },
  'recommendation.page.heading': {
    id: 'recommendation.page.heading',
    defaultMessage: 'We have a few recommendations to get you started.',
    description: 'recommendation page heading',
  },
  'recommendation.skip.button': {
    id: 'recommendation.skip.button',
    defaultMessage: 'Skip for now',
    description: 'Skip button text',
  },

});
export default messages;
